import { render, staticRenderFns } from "./otherDeclaration.vue?vue&type=template&id=0a694dfc&scoped=true&"
import script from "./otherDeclaration.vue?vue&type=script&lang=js&"
export * from "./otherDeclaration.vue?vue&type=script&lang=js&"
import style0 from "./otherDeclaration.vue?vue&type=style&index=0&id=0a694dfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a694dfc",
  null
  
)

export default component.exports